import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi) // Loads translations from your /public/locales folder
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    // Supported languages. 'en' is the fallback.
    // Add 'zh', 'es', 'hi' when you have those translation files.
    supportedLngs: ['en', 'zh', 'es', 'hi'], 
    fallbackLng: 'en', // Fallback language if detected language is not supported
    
    // Namespace for your translations. 'translation' is the default.
    // We'll load specific phase files.
    ns: ['phase0_event_centric', 'phase1_nexus_centric'],
    defaultNS: 'phase1_nexus_centric', // Start with phase1 for this exercise

    debug: process.env.NODE_ENV === 'development', // Enable debug output in development

    detection: {
      // Order and from where user language should be detected
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      // Keys or params to lookup language from
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
      
      caches: ['localStorage', 'cookie'], // Where to cache the detected language
      excludeCacheFor: ['cimode'], // Languages to not persist (e.g., 'cimode' for i18next-pseudo)
    },

    backend: {
      // Path where translations will be loaded from
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    react: {
      useSuspense: true, // Recommended: use Suspense for loading translations
    },
  });

export default i18n;